import api from '~/store/idonia-api/api'
import $state from '~/plugins/uploader/download-state.js'
import FILE_STATES from '~/plugins/uploader/file-states'
import store from '~/store/store'

export default {
  name: 'file.zipped',
  background (payload, {dispatch, state}, {sha, token, socket}) {
    const {fileID, taskUUID, task_id, url} = payload
    const downloadId = task_id || taskUUID

    if (!downloadId || downloadId === '') return

    const fileData = $state.files[downloadId]
    if (fileData && fileData.state && fileData.state.equals(FILE_STATES.canceled)) return

    $state.updateFileState(downloadId, FILE_STATES.completed)

    if (url) {
      api.downloadUrl(url)
      return
    }

    const endpoint = 'file/' + fileID + '/download/' + taskUUID
    const headers = sha
      ? { Authorization: store.getters['session/guestAuthentication'][sha] }
      : {}
    const { promise, xhr } = api.downloadBlobCancelable(endpoint, { headers })
    $state.updateFileXHR(downloadId, xhr)
    promise.catch(err => {
      const currentData = $state.files[downloadId]
      if (!currentData || !currentData.state || !currentData.state.equals(FILE_STATES.canceled)) {
        console.error(err)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/notifications/notifications/FileZipped.js